import CustomElement from "./CustomElement";

/**
 * Pagination
 * @augments CustomElement
 * @property {Function} bindLoadMore
 * @property {Function} loadData
 * @property {Function} renderGridWithPagination
 */
export default class Pagination extends CustomElement {

	constructor(){

		super();

		/**
		 * @member {string} section the shopify section this element binds to
		 * @member {string} type the type of pagination
		 */
		this.section = this.dataset.section;
		this.type = this.dataset.type;
		this.grid = document.querySelector(`#shopify-section-${this.section} .collection-grid .grid`);
		this.filters = document.querySelector(`#shopify-section-${this.section} filter-form`);

		if(this.type == "load-more" || this.type == "infinite") this.bindLoadMore();
	}

	/**
	 * Only fire this for "load-more" type
	 * @returns
	 */
	onViewportEnter() {

		if(this.type !== "infinite") return;

		this.loadData();
	}

	/**
	 *
	 */
	bindLoadMore() {

		/**
		 * @memberof! Pagination
		 */
		this.button = this.querySelector("a");
		this.button.addEventListener("click", (event) => {

			event.preventDefault();
			event.stopPropagation();

			this.loadData(event);
		});
	}

	/**
	 *
	 */
	loadData() {

		const link = this.button?.href;
		const url = `${link}&section_id=${this.section}`;

		/** --- Load from cache --- */
		if(this.filters.filterCache[this.link]) {

			this.renderGridWithPagination(this.filters.filterCache[this.link].html);

			return;
		}

		fetch(url)
			.then((response) => {

				if(!response.ok){

					let error = new Error(response.status);

					throw error;
				}

				return response.text();
			})
			.then((text) => {

				const html = text;

				this.filters.filterCache[this.link] = {
					html: html
				};

				this.renderGridWithPagination(html);
			})
			.catch((error) => {

				throw error;
			});
	}

	/**
	 *
	 * @param {string} html
	 * @returns
	 */
	renderGridWithPagination(html) {

		const dom = new DOMParser().parseFromString(html, "text/html");
		const fragment = document.createDocumentFragment();

		/** Update grid with items */
		let items = dom.querySelectorAll("article");

		fragment.append(...items);

		this.grid.appendChild(fragment);

		/** Load any images */
		window.Zero.lazyLoad.update();

		/** Update pagination */
		let pagination = dom.querySelector("paginate-grid");

		/** Self destroy */
		if(!pagination.innerHTML) {

			this.remove();

			return;
		}

		this.innerHTML = pagination.innerHTML;
		this.bindLoadMore();
	}
}
